import React from 'react'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'
import { fetchingState } from './../helpers/hocs.js'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import CheckForm from './../components/GiftCardsCheck'

import { check } from '../store/reducers/giftcards'

const GiftCardsCheckPage = ({ submit, pin, number, setData, checkProps, error }) => {
  return (
    <div>
      <div className='GiftCardsCheckContainer'>
        <div className='Container Container_light'>
          {/*<h1 className='Head GiftCards__title'>
            Проверка подарочной карты
          {/*<FormattedMessage id='contacts.address' />/}
  </h1>*/}
          <CheckForm from='checkContainer'/>
        </div>
      </div>

    </div>
  )
}

const mapStateToProps = state => ({
  currentLocale: state.intl.locale,
  //...state.giftcards//.checkProps,
})

const mapDispatchToProps = dispatch => bindActionCreators({ check }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  fetchingState({ multi: true }),
  withHandlers({
  })
)(GiftCardsCheckPage)



// WEBPACK FOOTER //
// ./src/containers/GiftCardsCheck.jsx